// Wrapper function rename a value if value present rename and change value
const renameKeyOfObjectOrSetValue = (object, { old_key, new_key}, value = undefined ) => {
    object[new_key] = value != undefined ? value : object[old_key];
    delete object[old_key];
}

export default renameKeyOfObjectOrSetValue;